module.exports = "./img/desktop_logo.ab85a48.png";